<!-- svelte-ignore a11y-label-has-associated-control -->
<!-- svelte-ignore a11y-missing-attribute -->

<div class="title has-text-centered">Your personal details</div>

<div class="field">
  <label class="label">First name</label>
  <div class="control">
    <input
      class="input"
      type="text"
      placeholder=""
      bind:value={firstName}
    />
  </div>
</div>

<div class="field">
  <label class="label">Last name</label>
  <div class="control">
    <input
      class="input"
      type="text"
      placeholder=""
      bind:value={lastName}
    />
  </div>
</div>
<div class="block">
  <button
    class="button is-primary"
    disabled={!isValid}
    on:click={submit}
    class:is-loading={isLoading}>Next</button
  >
</div>
{#if errorMessage}
  <div class="block">
    <div class="notification is-danger is-light">
      {errorMessage}
    </div>
  </div>
{/if}


<script lang="ts">
  import { goto } from "@sveltech/routify";
  import { appState } from "../../../lib/appState";
  import { logging } from '../../../lib/logging';

  // May be pre-populated
  let firstName : string = $appState.user ? $appState.user.firstName : '';
  let lastName : string = $appState.user ? $appState.user.lastName : '';

  $: isValid = firstName && lastName;

  let isLoading = false;
  let errorMessage : string;

  async function submit() {
    isLoading = true;

    let userUpdate = {
      firstName,
      lastName,
      created: new Date().toISOString()
    };

    try {
      await window.firebase
        .firestore()
        .doc("users_v1/" + $appState.auth_user.email)
        .set(userUpdate, { merge: true });

      let user = await window.firebase
        .firestore()
        .doc("users_v1/" + $appState.auth_user.email)
        .get()
        .then((doc) => doc.data() as User_v1);

      isLoading = false;
      $appState.user = user;
      $goto("org");
    } catch (err: any) {
      isLoading = false;
      logging.report(err.toString());
      errorMessage = err.toString();
    }
  }
</script>
